import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PriceEditarAdotado } from 'src/app/models/price-editar-adotado.model';
import { PriceModelService } from 'src/app/services/price-resumo.service';
import { Misc } from '../../util/misc';
import { ToastrComponent } from '../../util/toastr/toastr.component';

@Component({
  selector: 'app-price-edita-valor-adotado',
  templateUrl: './price-edita-valor-adotado.component.html',
  styleUrls: ['./price-edita-valor-adotado.component.scss']
})
export class PriceEditaValorAdotadoComponent implements OnInit {

  basicForm: UntypedFormGroup;
  loading = false;
  editarAdotado = false;
  id: any;

  constructor(
    public toastr: ToastrComponent,
    private priceModelService: PriceModelService,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public misc: Misc,
    private dialogRef: MatDialogRef<PriceEditaValorAdotadoComponent>) {
    this.createForm();
  }

  ngOnInit() {
    this.basicForm.patchValue({
      receitaBrutaAdotado: this.data.receitaBrutaAdotado.toFixed(2)
    });

    this.id = this.data.priceModel;
  }

  createForm() {
    this.basicForm = this.fb.group({
      receitaBrutaAdotado: [null, Validators.required]
    });
  }

  save() {

    this.loading = true;

    if (this.id != undefined || this.id != null) {

      const editarValorAdotado = {
        id: this.id.id,
        estimativaId: this.data.estimativaId,
        valor: this.basicForm.value.receitaBrutaAdotado
      } as PriceEditarAdotado

      this.priceModelService.editarReceitaAdotado(editarValorAdotado).subscribe(
        result => {
          this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Valores alterados com sucesso');
        },
        error => {
          this.misc.processError(error, 'Não foi possível atualizar a receita bruta adotada.');
        }
      ).add(() => {
        this.loading = false;
        this.close();
      });
    }

    else {

      const novoValorAdotado = {
        estimativaId: this.data.estimativaId,
        campo: "receitaBrutaAdotado",
        valor: this.basicForm.value.receitaBrutaAdotado,
        ativo: true
      } as PriceEditarAdotado

      this.priceModelService.adicionarReceitaAdotado(novoValorAdotado).subscribe(
        result => {
          this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Valores alterados com sucesso');
        },
        error => {
          this.misc.processError(error, 'Não foi possível atualizar a receita bruta adotada.');
        }
      ).add(() => {
        this.loading = false;
        this.close();
      });
    }
  }

  close() {
    this.dialogRef.close();
  }

}
